import { defineComponent as s, computed as l, openBlock as a, createElementBlock as m, normalizeStyle as n, normalizeClass as c } from "vue";
import { tw as o } from "../../utils/tailwind.js";
const z = /* @__PURE__ */ s({
  name: "RevColorSwatch",
  __name: "ColorSwatch",
  props: {
    color: {},
    size: { default: "medium" }
  },
  setup(e) {
    const r = l(() => ({
      small: o`size-12`,
      medium: o`size-16`
    })[e.size]);
    return (t, i) => (a(), m("div", {
      class: c(["border-static-default-dim rounded-md m-2 border-1", r.value]),
      style: n({ backgroundColor: e.color })
    }, null, 6));
  }
});
export {
  z as default
};
